import "./Location.css";
import React from "react";
import { Button } from "./Button";

export const Location = () => {
    return (
        <div className="block" id="Location">
            <div className="block_content">
                <h1>
                    Jak dojechać? <i className="fa-solid fa-location-pin"></i>
                </h1>
                <div id="map">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1781.2755029692137!2d19.130519075547607!3d50.84775884878026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4710b41dc200c635%3A0x851bc7fd751ab86d!2sGabinet%20Stomatologiczny%20Agnieszka%20Polis!5e0!3m2!1spl!2spl!4v1669834395832!5m2!1spl!2spl"
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="map"
                    ></iframe>        
                </div>
                <Button
                    link="https://goo.gl/maps/V6UcsBq6npJbEPCd6"
                    text="Nawiguj"
                    icon="fa-solid fa-compass"
                    class="navigate button"
                    target="blank"
                />
            </div>
        </div>
    );
};
